import { useParams } from 'react-router';
import PolicyApplicationForm from '@/components/policy-application/PolicyApplicationForm';

export function PolicyApplicationFormPage() {
  const { clientId, clientPolicyApplicationId, formId, forClientId } = useParams();

  if (!clientId || !clientPolicyApplicationId || !formId) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="mb-2 text-xl font-semibold text-gray-900">Form not found</h2>
          <p className="text-gray-600">The requested form could not be loaded.</p>
        </div>
      </div>
    );
  }

  return (
    <PolicyApplicationForm
      clientPolicyApplicationId={clientPolicyApplicationId}
      formId={formId}
      clientId={clientId}
      forClientId={forClientId as string}
    />
  );
}
